import esCR from "./es-CR";

export default {
    ...esCR,
}